import React, { useState } from 'react';
import { Button } from './ui/Button';
import { Scale, FileText, X, Send, CheckCircle, AlertCircle, Loader2, Clock } from 'lucide-react';
export function PlayerRightsSection() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    description: ''
  });
  const [status, setStatus] = useState<'idle' | 'submitting' | 'success' | 'error'>('idle');
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const {
      name,
      value
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setStatus('submitting');
    try {
      const response = await fetch('https://formsubmit.co/ajax/fgsukraine@gmail.com', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          ...formData,
          _subject: `Звернення від ${formData.name}`,
          _captcha: 'false'
        })
      });
      if (response.ok) {
        setStatus('success');
        setFormData({
          name: '',
          email: '',
          phone: '',
          description: ''
        });
      } else {
        setStatus('error');
      }
    } catch {
      setStatus('error');
    }
  };
  const closeModal = () => {
    setIsModalOpen(false);
    if (status === 'success') {
      setStatus('idle');
    }
  };
  return <>
      <section className="py-20 bg-[#F5F0E8]" data-id="element-444">
        <div className="container mx-auto px-4" data-id="element-445">
          <div className="text-center mb-16" data-id="element-446">
            <h2 className="text-3xl md:text-5xl font-serif font-bold text-[#0A5E5C] mb-4" data-id="element-447">
              Права гравців важливі
            </h2>
            <div className="h-1 w-24 bg-[#D4A843] mx-auto rounded-full mb-6" data-id="element-448" />
            <p className="text-gray-600 text-lg max-w-2xl mx-auto" data-id="element-449">
              Знання своїх прав — це перший крок до захисту. Ми надаємо юридичну
              підтримку та консультації.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-450">
            {/* Left Card */}
            <div className="bg-white p-8 md:p-10 rounded-xl shadow-sm border border-gray-100 flex flex-col items-start hover:shadow-md transition-shadow" data-id="element-451">
              <div className="flex items-center gap-3 mb-6" data-id="element-452">
                <div className="w-14 h-14 bg-[#0A5E5C]/10 rounded-full flex items-center justify-center" data-id="element-453">
                  <Scale className="w-8 h-8 text-[#0A5E5C]" data-id="element-454" />
                </div>
                <span className="inline-flex items-center gap-1.5 py-1 px-3 rounded-full bg-[#D4A843]/15 text-[#b88f32] border border-[#D4A843]/30 text-xs font-medium" data-id="element-455">
                  <Clock size={12} data-id="element-456" />У розробці
                </span>
              </div>
              <h3 className="text-2xl font-serif font-bold text-[#0A5E5C] mb-4" data-id="element-457">
                Знайте свої права
              </h3>
              <ul className="space-y-3 mb-8 text-gray-600 flex-grow" data-id="element-458">
                {['Право на чесну гру та прозорі правила', 'Право на своєчасну виплату виграшів', 'Право на захист персональних даних', 'Право на самообмеження'].map(right => <li key={right} className="flex items-center gap-2" data-id="element-459">
                    <span className="text-[#D4A843] font-bold" data-id="element-460">•</span>
                    <span className="flex-grow" data-id="element-461">{right}</span>
                    <span className="text-xs text-gray-400 border border-gray-200 rounded-full px-2 py-0.5 flex-shrink-0" data-id="element-462">
                      Скоро
                    </span>
                  </li>)}
              </ul>
              <Button variant="primary" disabled data-id="element-463">
                У розробці — незабаром
              </Button>
            </div>

            {/* Right Card */}
            <div className="bg-white p-8 md:p-10 rounded-xl shadow-sm border border-gray-100 flex flex-col items-start hover:shadow-md transition-shadow" data-id="element-464">
              <div className="w-14 h-14 bg-[#D4A843]/10 rounded-full flex items-center justify-center mb-6" data-id="element-465">
                <FileText className="w-8 h-8 text-[#D4A843]" data-id="element-466" />
              </div>
              <h3 className="text-2xl font-serif font-bold text-[#0A5E5C] mb-4" data-id="element-467">
                Подати звернення
              </h3>
              <p className="text-gray-600 mb-8 leading-relaxed flex-grow" data-id="element-468">
                Якщо Вам потрібна правова допомога або Ви зіштовхнулися з
                порушенням Ваших прав в сфері азартних ігор, Ви можете подати
                звернення через наш сайт
              </p>
              <Button variant="secondary" onClick={() => setIsModalOpen(true)} data-id="element-469">
                Подати звернення
              </Button>
            </div>
          </div>
        </div>
      </section>

      {/* Modal Overlay */}
      {isModalOpen && <div className="fixed inset-0 z-50 flex items-center justify-center p-4" onClick={closeModal} data-id="element-470">
          {/* Backdrop */}
          <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" data-id="element-471" />

          {/* Modal Content */}
          <div className="relative bg-white rounded-xl shadow-2xl w-full max-w-lg max-h-[90vh] overflow-y-auto" onClick={e => e.stopPropagation()} data-id="element-472">
            {/* Header */}
            <div className="sticky top-0 bg-white rounded-t-xl border-b border-gray-100 px-6 py-4 flex items-center justify-between z-10" data-id="element-473">
              <h3 className="text-xl font-serif font-bold text-[#0A5E5C]" data-id="element-474">
                Подати звернення
              </h3>
              <button onClick={closeModal} className="w-8 h-8 rounded-full flex items-center justify-center text-gray-400 hover:text-gray-600 hover:bg-gray-100 transition-colors" data-id="element-475">
                <X className="w-5 h-5" data-id="element-476" />
              </button>
            </div>

            <div className="p-6" data-id="element-477">
              {status === 'success' ? <div className="text-center py-8" data-id="element-478">
                  <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-5" data-id="element-479">
                    <CheckCircle className="w-8 h-8 text-green-600" data-id="element-480" />
                  </div>
                  <h4 className="text-xl font-serif font-bold text-[#0A5E5C] mb-3" data-id="element-481">
                    Дякуємо за звернення!
                  </h4>
                  <p className="text-gray-600 mb-6" data-id="element-482">
                    Ми отримали ваше звернення і зв'яжемося з вами найближчим
                    часом.
                  </p>
                  <Button variant="outline" onClick={closeModal} data-id="element-483">
                    Закрити
                  </Button>
                </div> : <form onSubmit={handleSubmit} className="space-y-5" data-id="element-484">
                  <p className="text-gray-600 text-sm mb-2" data-id="element-485">
                    Заповніть форму нижче, і наша команда розгляне ваше
                    звернення.
                  </p>

                  <div className="space-y-1.5" data-id="element-486">
                    <label htmlFor="modal-name" className="block text-sm font-medium text-[#0A5E5C]" data-id="element-487">
                      Ім'я та Прізвище
                    </label>
                    <input type="text" id="modal-name" name="name" required value={formData.name} onChange={handleChange} className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:border-[#0A5E5C] focus:ring-2 focus:ring-[#0A5E5C]/20 outline-none transition-all" placeholder="Ваше ім'я" data-id="element-488" />
                  </div>

                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-489">
                    <div className="space-y-1.5" data-id="element-490">
                      <label htmlFor="modal-email" className="block text-sm font-medium text-[#0A5E5C]" data-id="element-491">
                        Email
                      </label>
                      <input type="email" id="modal-email" name="email" required value={formData.email} onChange={handleChange} className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:border-[#0A5E5C] focus:ring-2 focus:ring-[#0A5E5C]/20 outline-none transition-all" placeholder="email@example.com" data-id="element-492" />
                    </div>

                    <div className="space-y-1.5" data-id="element-493">
                      <label htmlFor="modal-phone" className="block text-sm font-medium text-[#0A5E5C]" data-id="element-494">
                        Телефон
                      </label>
                      <input type="tel" id="modal-phone" name="phone" required value={formData.phone} onChange={handleChange} className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:border-[#0A5E5C] focus:ring-2 focus:ring-[#0A5E5C]/20 outline-none transition-all" placeholder="+38 (0XX) XXX-XX-XX" data-id="element-495" />
                    </div>
                  </div>

                  <div className="space-y-1.5" data-id="element-496">
                    <label htmlFor="modal-description" className="block text-sm font-medium text-[#0A5E5C]" data-id="element-497">
                      Опис ситуації
                    </label>
                    <textarea id="modal-description" name="description" rows={4} required value={formData.description} onChange={handleChange} className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:border-[#0A5E5C] focus:ring-2 focus:ring-[#0A5E5C]/20 outline-none transition-all resize-none" placeholder="Опишіть детально, що сталося..." data-id="element-498"></textarea>
                  </div>

                  {status === 'error' && <div className="flex items-center gap-2 text-red-600 bg-red-50 p-3 rounded-lg border border-red-100" data-id="element-499">
                      <AlertCircle className="w-5 h-5 flex-shrink-0" data-id="element-500" />
                      <p className="text-sm" data-id="element-501">
                        Виникла помилка. Будь ласка, спробуйте ще раз.
                      </p>
                    </div>}

                  <Button type="submit" variant="secondary" size="lg" className="w-full flex items-center justify-center gap-2" disabled={status === 'submitting'} data-id="element-502">
                    {status === 'submitting' ? <>
                        <Loader2 className="w-5 h-5 animate-spin" data-id="element-503" />
                        Відправка...
                      </> : <>
                        <Send className="w-5 h-5" data-id="element-504" />
                        Надіслати звернення
                      </>}
                  </Button>

                  <p className="text-xs text-center text-gray-500" data-id="element-505">
                    Натискаючи кнопку, ви погоджуєтесь на обробку персональних
                    даних
                  </p>
                </form>}
            </div>
          </div>
        </div>}
    </>;
}